import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

const useNavigateWithMergedParams = () => {
	const router = useRouter();
	const searchParams = useSearchParams();

	return useCallback(
		(
			pathname: string,
			params: Record<string, string>,
			action: keyof Omit<AppRouterInstance, 'back' | 'forward' | 'refresh'>,
			anchor?: string,
			scroll?: boolean,
		) => {
			const urlSearch = new URLSearchParams({
				...Object.fromEntries(searchParams),
				...params,
			});

			if (action === 'replace') {
				router.replace(`${pathname}?${urlSearch.toString()}${anchor ? `#${anchor}` : ''}`, { scroll: scroll ?? false });
			} else {
				router.push(`${pathname}?${urlSearch.toString()}${anchor ? `#${anchor}` : ''}`);
			}
		},
		[searchParams, router],
	);
};

export default useNavigateWithMergedParams;
